<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'Translation',
  created: function () {
    this.$emit('activeMenu', '/admin/translation')
    this.$emit('updateTitle', this.$translate.t('Translation List'))
    this.$emit('updateDisable', true)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/translation/Translation.vue